// extracted by mini-css-extract-plugin
export default {"heroContainer":"heroSection_heroContainer__4WVAn","video":"heroSection_video__T+9gS","overlay":"heroSection_overlay__xoYN4"};